export default "__VITE_ASSET__bfp$44M9__"